// extracted by mini-css-extract-plugin
export default {"accountInfoContainer":"AccountInfo_accountInfoContainer__XhN5+"};